import React, { useEffect, useRef, useState } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./VideoModal.css";

const VideoModal = ({ isPlayerOpen, setIsPlayerOpen, videoUrl }) => {
  const videoNode = useRef(null);
  const player = useRef(null);

  const [audioTracks, setAudioTracks] = useState([]);
  const [selectedTrack, setSelectedTrack] = useState(0);
  const [selectedPlayer, setSelectedPlayer] = useState(null); // 'videojs' | 'html5' | 'vlc'
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (isPlayerOpen && selectedPlayer === "videojs" && videoNode.current) {
      player.current = videojs(videoNode.current, {
        controls: true,
        autoplay: true,
        preload: "auto",
        responsive: true,
        fluid: true,
        sources: [{ src: videoUrl, type: "video/mp4" }],
      });

      player.current.on("loadedmetadata", () => {
        const tracks = player.current.audioTracks();
        if (tracks && tracks.length > 0) {
          const tracksArray = Array.from({ length: tracks.length }, (_, index) => ({
            id: index,
            label: tracks[index].label || `Áudio ${index + 1}`,
          }));
          setAudioTracks(tracksArray);
        }
      });

      player.current.on("error", () => {
        setErrorMsg("Erro ao reproduzir — tente outro player abaixo 👇");
      });
    }

    return () => {
      if (player.current) {
        player.current.dispose();
        player.current = null;
      }
    };
  }, [isPlayerOpen, selectedPlayer, videoUrl]);

  const handleTrackChange = (trackIndex) => {
    const tracks = player.current.audioTracks();
    if (tracks) {
      tracks.forEach((track, index) => {
        track.enabled = index === trackIndex;
      });
      setSelectedTrack(trackIndex);
    }
  };

  const onClose = () => {
    setSelectedPlayer(null);
    setErrorMsg("");
    setIsPlayerOpen(false);
    if (player.current) {
      player.current.dispose();
      player.current = null;
    }
  };

  const renderPlayerSelector = () => (
    <div className="player-select-screen">
      <h3>Escolha um player:</h3>
      <div className="player-buttons">
        <button onClick={() => setSelectedPlayer("videojs")}>🎬 Player 1 (VideoJS)</button>
        <button onClick={() => setSelectedPlayer("html5")}>💻 Player 2 (HTML5)</button>
        <a href={videoUrl} target="_blank" rel="noopener noreferrer">
          <button>🔗 Player 3 (Abrir Externo)</button>
        </a>
      </div>
    </div>
  );

  const renderVideoJSPlayer = () => (
    <>
      <div data-vjs-player>
        <video ref={videoNode} className="video-js" />
      </div>
      {audioTracks.length > 0 && (
        <div className="audio-selector">
          <label>Selecione o áudio:</label>
          <select
            value={selectedTrack}
            onChange={(e) => handleTrackChange(Number(e.target.value))}
          >
            {audioTracks.map((track) => (
              <option key={track.id} value={track.id}>
                {track.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {errorMsg && (
        <div className="error-message">
          <p>{errorMsg}</p>
          <button onClick={() => setSelectedPlayer("html5")}>
            Tentar Player 2 (HTML5)
          </button>
        </div>
      )}
    </>
  );

  const renderHTML5Player = () => (
    <div className="html5-player-container">
      <video
        src={videoUrl}
        controls
        autoPlay
        style={{ width: "100%", borderRadius: "8px" }}
        onError={() =>
          setErrorMsg("HTML5 também não conseguiu reproduzir este vídeo 😢")
        }
      />
      {errorMsg && (
        <div className="error-message">
          <p>{errorMsg}</p>
          <a href={videoUrl} target="_blank" rel="noopener noreferrer">
            <button>Abrir no Player Externo</button>
          </a>
        </div>
      )}
    </div>
  );

  return (
    isPlayerOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="video-container">
            {!selectedPlayer && renderPlayerSelector()}
            {selectedPlayer === "videojs" && renderVideoJSPlayer()}
            {selectedPlayer === "html5" && renderHTML5Player()}
            <button className="close-button" onClick={onClose}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default VideoModal;
